const adminFields = `
	id
	email
	is_saas
	is_super
	events {
		id
		name
		client_id
	}
	clients {
		id
		name
	}
	perms {
		id
		permission
		event {
			id
			name
			client_id
		}
	}
`;

export const CREATE_SAAS_ADMIN = `
	mutation createSAASAdmin($email: String!) {
		createSAASAdmin(email: $email) {
			${adminFields}
		}
	}
`;
